import React, { useState, useEffect, useCallback } from "react";
import { Grid, CardHeader, CardContent, Box, TextField, Button } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import { Helmet } from "react-helmet-async";
import { Form, FormikProvider, useFormik } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import CardLayout from "../../layouts/CardLayout";
import errorHandler from "../../utils/errorHandler";
import { ticketManagementServices } from "../../services/AllServices";
import { ResultDeclareSchema, ticketManagementSchema } from "../../utils/Schema";
import { LocalizationProvider, MobileDatePicker, } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { IMAGE_BASE } from "../../utils/constants";
import { useLocation } from "react-router-dom";


function ResultUpload() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [resultID, setID] = useState(null);
  const [preview, setPreview] = useState("");
  const [data, setData] = useState(null);
  const location = useLocation();
  const resultDate = location?.state?.resultDate || null;

  const fetchTaskData = useCallback(async () => {
    if (id) {
      setLoading(true);
      try {
        const payload = {
          ticketId: id,
          resultDate: resultDate,
        }
        const response = await ticketManagementServices.getOneResult(payload);
        setPreview(IMAGE_BASE + response?.data?.data.image)
        setID(response?.data?.data?._id);
        setData(response?.data?.data?.image);
      } catch (error) {
        // errorHandler(error);
      } finally {
        setLoading(false);
      }
    }
  }, [id]);

  useEffect(() => {
    fetchTaskData();
  }, [fetchTaskData]);

  const formik = useFormik({
    enableReinitialize: true,
    validationSchema: ResultDeclareSchema,
    initialValues: {
      image: data || '',
    },
    onSubmit: async (values) => {
      setLoading(true);
      try {
        const formData = new FormData();
        if (resultID) {
          formData.append("resultId", resultID);
        }

        formData.append("ticketId", id);
        formData.append("imagePath", "resultImage");
        Object.keys(values).forEach((key) => {
          if (values[key]) {
            formData.append(key, values[key]);
          }
        });
        const response = resultID ? await ticketManagementServices.UpdateResult(formData) : await ticketManagementServices.addResult(formData);
        toast.success(response?.data?.message, { toastId: "success" });
        navigate('/tickets-management');
      } catch (error) {
        errorHandler(error);
      } finally {
        setLoading(false);
      }
    },
  });

  const {
    values,
    touched,
    errors,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = formik;

  const handleImageChange = (event) => {
    const file = event.currentTarget.files[0];
    if (file) {
      const validFormats = ["image/jpeg", "image/png" , "image/jpg"];
      if (validFormats.includes(file.type)) {
        setFieldValue("image", file);
        setPreview(URL.createObjectURL(file));
      } else {
        toast.error("Invalid image format. Only JPG, JPEG, and PNG are allowed.");
      }
    }
  };

  return (
    <Box>
      <CardLayout>
        <CardHeader title={`${resultID ? "Edit" : "Add"} Result`} />
        <CardContent>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <FormikProvider value={formik}>
              <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <Box
                      display="flex"
                      flexDirection="column"
                      alignItems="center"
                      mb={3}
                    >
                      <Box
                        sx={{
                          width: 100,
                          height: 100,
                          borderRadius: "50%",
                          overflow: "hidden",
                          border: "2px solid #ccc",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          backgroundColor: "#e0e0e0",
                          fontSize: 30,
                          color: "#444",
                        }}
                      >
                        {preview ? (
                          <img
                            src={preview || '/assets/images/ticket.png'}
                            alt="Uploaded"
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                          />
                        ) : (
                       
                          <img
                          src={'/assets/images/ticket.png'}
                          alt="Uploaded"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                        )}
                      </Box>

                      <Button
                        variant="contained"
                        component="label"
                        sx={{
                          mt: 2,
                          backgroundColor: "#2196f3",
                          boxShadow: 3,
                          ":hover": { backgroundColor: "#1976d2" },
                        }}
                      >
                        Upload Image
                        <input
                          type="file"
                          hidden
                          accept="image/*"
                          onChange={handleImageChange}
                        />
                      </Button>

                      {touched.image && errors.image && (
                        <Box color="error.main" mt={1}>
                          {errors.image}
                        </Box>
                      )}
                    </Box>

                  </Grid>

                  <Grid item xs={12}>
                    <Box mt={3}>
                      <LoadingButton
                        fullWidth
                        size="large"
                        type="submit"
                        variant="contained"
                        loading={loading}
                      >
                        {resultID ? "Update" : "Add"} Result
                      </LoadingButton>
                    </Box>
                  </Grid>
                </Grid>
              </Form>
            </FormikProvider>
          </LocalizationProvider>
        </CardContent>
      </CardLayout>
    </Box>
  );
}

export default ResultUpload;
